<template>
<div v-if="this.$store.state.is_auth && this.$store.state.user_type === 'client'">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				{{ localErrorMessage | ftc }}
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
			</div>
		</transition>

		<!-- Дежурный текст -->
		<h3>Пользователи аккаунта</h3>
		<br>
		
		<div>
			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ultrices sollicitudin metus, non finibus nisi pellentesque rhoncus. Fusce et erat laoreet, elementum erat non, tincidunt risus. Aliquam et condimentum sem. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis dolor justo, blandit ac purus non, convallis porttitor mauris. Nulla cursus, nulla ac hendrerit mollis, turpis magna eleifend diam, et luctus nisi ligula quis ipsum. Integer ut interdum tortor.
			</p>
			<p>
				Sed ut est in orci interdum dapibus a eu arcu. Sed eget tortor velit. Fusce vitae justo at tortor posuere finibus id et massa. Cras lacinia risus euismod, consectetur eros blandit, vehicula sem. Suspendisse ipsum neque, faucibus ac hendrerit consequat, tempor eu justo. Suspendisse est orci, porttitor id risus at, mattis varius diam. Aenean malesuada eros accumsan sem efficitur imperdiet id et lorem. Aliquam erat volutpat. Suspendisse et eros eu erat tincidunt aliquam consequat quis mi. Sed nulla augue, ultricies nec odio ac, pretium ornare eros. Suspendisse potenti. Praesent iaculis, orci vitae lacinia venenatis, metus leo egestas libero, ut congue velit lorem aliquam ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Maecenas ultrices tellus ut nibh fringilla, ac finibus velit euismod. Proin rutrum dictum augue eget sodales. Nam ultrices nulla sed massa lacinia feugiat in nec nulla.
			</p>
		</div>
		<!-- ================================= -->

	</template>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Users',
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// закешированные данные
			dataUsers: false,

			// наименование CRUD-объекта
			crud: 'users',

			// локальное сообщение об ошибке
			localErrorMessage: ''
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			return this.$store.state.clientConfig
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// сразу запрашиваем данные формы
		this.requestInfo()
	},
	//=========================================================================
	// метолы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestInfo() {
			/*
			// делаем запрос
			this.$http.get(this.APIServerUrl + '/bonus/convert').then(
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value'])
					{
						this.accountId = _dt['fields']['account_id']['value']
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(res)
				},
				res => { this.localErrorMessage = this.formatRequestError(res) }
			)
			*/
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// Users.vue?46519c63